<template>
  <a class="support-btn" v-if="payfactoSupport" :href="payfactoSupport.url[$ts.state.locale]" target="_blank">
    <div class="dot" v-if="dot"></div>
    {{$t('payfacto_support.' + payfactoSupport.type)}}
  </a>
</template>

<script>
  export default {
    name: "payfactoSupportUrl",

    props: {
      dot: Boolean
    },

    computed: {
      payfactoSupport() {
        let company = this.$store.state.contextCompany;
        if (company && company.activePOS && company.activePOS[0]) {
          switch(company.activePOS[0]) {
            case "veloce":
              return {
                type: "veloce",
                url: {
                  fr: "documents/iShopFood - Depannage Payfacto V.pdf",
                  en: "documents/iShopFood - Payfacto Troubleshooting V.pdf"
                }
              };
            case "maitre":
              return {
                type: "maitre",
                url: {
                  fr: "documents/iShopFood - Depannage Payfacto MD.pdf",
                  en: "documents/iShopFood - Payfacto Troubleshooting MD.pdf"
                }
              };
            default: {
              return null;
            }
          }
        }

        return null;
      }
    }
  }
</script>

<style lang="scss">
  .dot {
    width: 10px;
    height: 10px;
    border: 2px solid #404040;
    border-radius: 10px;
    margin-right: 10px;
    margin-left: 10px;
  }
</style>
